// src/utils.js

// Mask phone numbers in text to prevent accidental exposure
export const maskPhoneNumbers = (text) => {
    if (!text) return text;

    // Match any sequence with optional +, followed by digits/spaces/dashes/brackets
    // Then filter by counting actual digits (must have 9+)
    return text.replace(/\+?[\d\s\-\(\)\[\]]{10,}(?:\D|$)/gi, (match) => {
        // Count the actual digits in this match (ignoring spaces, dashes, brackets)
        const digitCount = (match.match(/\d/g) || []).length;

        // If 9+ digits, mask it; otherwise return as-is
        if (digitCount >= 9) {
            // Preserve any trailing non-digit character
            const trailingChar = match.match(/\D$/)?.[0] || '';
            return '[PHONE REDACTED]' + trailingChar;
        }
        return match;
    });
};

export const getAuthErrorMessage = (errorCode) => {
    switch (errorCode) {
        case 'auth/email-already-in-use':
            return 'This email address is already in use. Please log in or use a different email.';
        case 'auth/invalid-email':
            return 'The email address is not valid.';
        case 'auth/weak-password':
            return 'The password is too weak. It must be at least 6 characters long.';
        case 'auth/user-not-found':
        case 'auth/wrong-password':
            return 'Invalid email or password.';
        case 'auth/popup-closed-by-user':
            return 'The sign-in window was closed.';
        default:
            return 'An unknown authentication error occurred. Please try again.';
    }
};